import { AuthorizedAppModel } from "./authorized-app.model";

export class PolicyModel {
    userEmail: string;
    userFullName: string;
    userRole: number;
    userCountry: string;
    authorizedApps: Array<AuthorizedAppModel>;
    createdDate: string;
    updatedDate: string;
    // Optional
    id?: string;
    currentUserRole?: number;
}
